export default [
    {
        path: '/financiero/aprobacion-ordenes-requisicion',
        name: 'financiero-aprobacion-ordenes-requisicion',
        component: () => import('@/views/pages/financiero/aprobaciones/AprobOrdReq.vue'),
        meta: {
            title: 'i18n:financiero.transacciones.aprobacion_ordenes_requisicion.title',
            resource: 'Financiero',
            action: 'ver-financiero-aprobacion-ordenes-requisicion',
            pageTitle: 'Aprobación Órdenes Requisición',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Apro. Ord. Requisición',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/operaciones-resumen',
        name: 'financiero-operaciones-resumen',
        component: () => import('@/views/pages/financiero/operaciones/Resumen.vue'),
        meta: {
            title: 'i18n:financiero.informes.resumen.title',
            resource: 'Financiero',
            action: 'ver-financiero-operaciones-resumen',
            pageTitle: 'Resumen de Operaciones Bancarias',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Resumen',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/administacion',
        name: 'financiero-administacion',
        component: () => import('@/views/pages/financiero/administracion/Administracion.vue'),
        meta: {
            title: 'i18n:financiero.transacciones.operaciones_bancarias.title',
            resource: 'Financiero',
            action: 'ver-financiero-administacion',
            pageTitle: 'Administración',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Administración',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/provisiones-mensuales',
        name: 'financiero-provisiones-mensuales',
        component: () => import('@/views/pages/financiero/administracion/ProvisionesMensuales.vue'),
        meta: {
            title: 'i18n:financiero.transacciones.provisiones_mensuales.title',
            resource: 'Financiero',
            action: 'ver-financiero-provisiones-mensuales',
            pageTitle: 'Provisiones Mensuales de Operaciones Bancarias',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Provisiones Mensuales de Operaciones Bancarias',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/reportes',
        name: 'financiero-reportes',
        component: () => import('@/views/pages/financiero/reportes/Reportes.vue'),
        meta: {
            title: 'i18n:financiero.informes.reportes.title',
            resource: 'Financiero',
            action: 'ver-financiero-reportes',
            pageTitle: 'Reportes',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Reportes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/activar-cuentas-bancarias',
        name: 'financiero-activar-cuentas-bancarias',
        component: () => import('@/views/pages/financiero/cuentas/ActivarCuentas.vue'),
        meta: {
            title: 'i18n:financiero.mantenimiento.cuentas_bancarias.title',
            resource: 'Financiero',
            action: 'ver-financiero-activar-cuentas-bancarias',
            pageTitle: 'Activar Cuentas Bancarias',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Activar Cuentas Bancarias',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/administracion-clientes',
        name: 'financiero-administracion-clientes',
        component: () => import('@/views/pages/financiero/administracion/AdminisClientes.vue'),
        meta: {
            title: 'i18n:financiero.mantenimiento.clientes.title',
            resource: 'Financiero',
            action: 'ver-financiero-administracion-clientes',
            pageTitle: 'Administración Clientes',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Administración Clientes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/administracion-deudores',
        name: 'financiero-administracion-deudores',
        component: () => import('@/views/pages/financiero/administracion/AdminisDeudores.vue'),
        meta: {
            title: 'i18n:financiero.mantenimiento.deudores.title',
            resource: 'Financiero',
            action: 'ver-financiero-administracion-deudores',
            pageTitle: 'Administración Deudores',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Administración Deudores',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/reportes-stock-inventario',
        name: 'financiero-reportes-stock-inventario',
        component: () => import('@/views/pages/financiero/reportes/ReporteStockInventario.vue'),
        meta: {
            title: 'i18n:financiero.informes.stock_inventario.title',
            resource: 'Financiero',
            action: 'ver-financiero-reportes-stock-inventario',
            pageTitle: 'Reporte Stock Inventario',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Reporte Stock Inventario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/archivos-transferencia',
        name: 'financiero-archivos-transferencia',
        component: () => import('@/views/pages/financiero/transacciones/ArchivosTransferencia.vue'),
        meta: {
            title: 'i18n:financiero.transacciones.archivos_transferencia.title',
            resource: 'Financiero',
            action: 'ver-financiero-archivos-transferencia',
            pageTitle: 'Archivos Transferencia',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Archivos Transferencia',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/financiero/seguimiento-operaciones',
        name: 'financiero-seguimiento-operaciones',
        component: () => import('@/views/pages/financiero/reportes/SeguimientoOperaciones.vue'),
        meta: {
            title: 'i18n:financiero.informes.reportes.title',
            resource: 'Financiero',
            action: 'ver-financiero-reportes',
            pageTitle: 'Seguimiento Operaciones',
            breadcrumb: [
                {
                    text: 'Financiero',
                },
                {
                    text: 'Seguimiento Operaciones',
                    active: true,
                },
            ],
        },
    },
]
